export const questions = [
  { id: 1, name: 'cruds.questionaries.selectionSimple' },
  { id: 2, name: 'cruds.questionaries.selectionMultiple' },
  { id: 4, name: 'cruds.questionaries.numeric' },
  { id: 5, name: 'cruds.questionaries.opened' },
]
